/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import * as R from 'ramda';

const iconStyles = { position: 'absolute', right: 12, top: 14 };

const renderInput = R.curry(
  ({ label, loading, length, showNoOptions = true, error = false, selectedCount = 0 }, params) => (
    <TextField
      {...params}
      error={error}
      label={label}
      slotProps={{
        htmlInput: { ...params.inputProps },

        input: {
          ...params.InputProps,
          endAdornment: (
            <>
              {loading ? (
                <CircularProgress size={20} sx={{ color: 'secondary.main' }} />
              ) : !loading && showNoOptions && !length && selectedCount === 0 ? (
                <Tooltip title="No options available">
                  <InfoRoundedIcon sx={{ color: 'graphic.main', ...iconStyles }} />
                </Tooltip>
              ) : null}
              {!!length && params.InputProps.endAdornment}
            </>
          ),
        },
      }}
    />
  )
);

export default renderInput;
